/**
 *  Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein.
 */

module.exports = {
  sorModal: require('./sorModal'),
  sorLoader: require('./sorLoader'),
  sorCharLimitation: require('./sorCharLimitation'),
  sorUtils: require('./sorUtils'),
  sorValidation: require('./sorValidation'),
  sorMultiPack: require('./sorMultiPack')
};
